// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper__progress-bar[data-v-135718c5]{display:flex;justify-content:space-between}.progress[data-v-135718c5]{border-radius:4px;background-color:#e9ecef}.progress-bar[data-v-135718c5]{border-radius:4px;transition:width .6s ease}.text__mc-type[data-v-135718c5]{font-weight:500}.text__learning-progress[data-v-135718c5]{font-size:16px;font-weight:400;color:#3b3e66}.progress-container[data-v-135718c5]{height:8px;width:80%}.level-type-icon[data-v-135718c5]{height:16px}", ""]);
// Exports
module.exports = exports;
